<script setup lang="ts">
import { RouterLink, RouterView, useRouter } from 'vue-router'
import HelloWorld from './components/HelloWorld.vue'
import { useGlobalStore } from '@/stores/global'
import { useIsFetching, useIsMutating, useQueryClient } from '@tanstack/vue-query'
import type { ComponentExposed } from 'vue-component-type-helpers'
import { inject, onMounted, provide, ref, type Component } from 'vue'
import AwaitableModal from './components/shared/AwaitableModal.vue'
import Button from './components/Button.vue'
import axios from '@/plugins/axios'
import { useTrackingSession } from './services/tracking-sessions'

const appStore = useGlobalStore()

const isFetching = useIsFetching()
const isMutating = useIsMutating()
const queryClient = useQueryClient()

const awaitableModal = ref<null | ComponentExposed<typeof AwaitableModal>>(null)

function cancel() {
  queryClient.cancelQueries()
}

useTrackingSession()

provide('modal', awaitableModal)
</script>

<template>
  <template v-if="isFetching || appStore.loading || isMutating">
    <div class="fixed w-screen h-screen top-0 left-0 bg-black bg-opacity-50 z-[99]" />
    <div
      class="fixed bg-white rounded-lg p-5 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[99] flex flex-col gap-3 items-center w-full max-w-xs"
    >
      <span class="icon-[eos-icons--loading] size-6"></span>
      <div>جاري التحميل</div>

      <Button @click="cancel" type="outline-danger"> إلغاء </Button>
    </div>
  </template>

  <AwaitableModal ref="awaitableModal" />

  <RouterView :key="$route.fullPath" />
</template>

<style>
.router-link-active {
  @apply bg-white text-primary rounded-lg fill-primary;
}
</style>
